import * as yup from "yup";
import { additionalFieldTypes } from "./additionalFieldTypes";

const schema = yup.object().shape({
  name: yup.string().required("Name is required"),
  type: yup
    .string()
    .oneOf(additionalFieldTypes.map(field => field.type), "Type is required")
    .required("Type is required"),
  configuration: yup.object()
    .when("type", function (type, schema) {
      const field = additionalFieldTypes.find(field => field.type === type)

      if (!field) return schema

      if (field.schema) return field.schema

      return schema.shape({
        minLength: yup.number().nullable(true),
        maxLength: yup.number().nullable(true),
      })
    }),
  placeholder: yup.string().max(200).nullable(true),
  required: yup.boolean().required("Required field is required"),
  skills: yup.array().of(yup.string().uuid()).required("At least one skill is required"),
  key: yup.string().required("Key is required"),
});


export default schema; 